export const SWATCH_GAP = {
  desktop: 8,
  mobile: 16,
};

export const SWATCH_WIDTH = {
  desktop: 62,
  mobile: 58,
};
